import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import DataCaptureComponent from './js/data-capture.component';

ComponentsFactory.getInstance().define('data-capture', DataCaptureComponent);
